import { z } from 'zod';
import { CareDocumentDataSchema } from './CareDocumentDataSchema';
import { IObject } from '../../IObject';
import { dateValidation } from '../../../validation';

export const LandgCareDocumentDataSchema = CareDocumentDataSchema.extend({
  sentToCaseManager: z
    .object({
      at: dateValidation(),
      by: z.string().nullish(),
      // whether the member was CC'd (PPL-3293); absent on stamps written
      // before the CC option existed
      ccMember: z.boolean().optional(),
    })
    .optional(),
});

export type LandgCareDocumentData = z.infer<typeof LandgCareDocumentDataSchema>;
export type LandgCareDocument = IObject.HasIdTimestamped<LandgCareDocumentData>;
